/** A factual handover worksheet. Access terms must be approved by the project's advocate. */
export async function downloadFitoutAccessForm(args: {
  project: string;
  building: string;
  unit: string;
  customer: string;
}): Promise<void> {
  const { jsPDF } = await import('jspdf');
  const pdf = new jsPDF({ unit: 'mm', format: 'a4' });
  let y = 18;
  const line = (label: string, value = '') => {
    pdf.text(`${label}: ${value}`, 16, y);
    y += 8;
  };
  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(15);
  pdf.text('FIT-OUT ACCESS AND UNIT CONDITION RECORD', 16, y);
  y += 12;
  pdf.setFont('helvetica', 'normal');
  pdf.setFontSize(10);
  line('Project', args.project);
  line('Building', args.building);
  line('Unit', args.unit);
  line('Customer', args.customer);
  line('Inspection / access date', '________________');
  y += 4;
  pdf.setFont('helvetica', 'bold');
  pdf.text('Purpose and access', 16, y);
  y += 7;
  pdf.setFont('helvetica', 'normal');
  pdf.text('Limited access for furniture or interior work. Final possession is recorded separately after BUC.', 16, y);
  y += 10;
  line('Approved access terms / reference', '________________________________________');
  line('Contractor name and contact', '________________________________________');
  line('Keys / access cards issued', '________________________________________');
  y += 3;
  pdf.setFont('helvetica', 'bold');
  pdf.text('Joint unit condition checklist', 16, y);
  y += 8;
  pdf.setFont('helvetica', 'normal');
  const checks = [
    'Entrance door, locks and keys',
    'Walls, ceiling and paint',
    'Flooring and tiles',
    'Windows, glazing and balcony',
    'Electrical points and fixtures',
    'Plumbing, sanitary fittings and leaks',
    'Water meter reading',
    'Electricity meter reading',
    'Photographs and open defects attached',
  ];
  checks.forEach((item) => {
    pdf.rect(16, y - 3.5, 4, 4);
    pdf.text(item, 24, y);
    y += 8;
  });
  y += 3;
  line('Open defects / exclusions', '________________________________________');
  line('Six-month maintenance cheque no.', '________________');
  line('Cheque date / bank / amount', '________________________________________');
  y += 8;
  line('Customer signature', '________________________');
  line('Company representative signature', '________________________');
  y += 4;
  pdf.setFontSize(8);
  pdf.text('Internal draft: have the approved access terms reviewed before issuing this form.', 16, y);
  const safeUnit = args.unit.replace(/[^a-zA-Z0-9_-]+/g, '_') || 'unit';
  pdf.save(`${safeUnit}_fitout_access_condition_record.pdf`);
}
